<!--通用的头部-->
<template>
  <div class="headerMain">
    <div class="logoAndNav">
      <div class="logoShow" @click="toIndex">
        <img :src="imagePathLogo" alt="">
      </div>
      <div class="navList">
        <ul>
          <li v-for="item in menuList" :key="item.id + 'menuList'"  class="navListShow"
              :class="item.id === menuActive?'navListActive':''" @click="menuClick(item)">
            {{item.label}}
          </li>
        </ul>
      </div>
    </div>
    <div class="languageList">
      <div class="languageListShow" v-for="(item,i) in languageList" :key="item.id + 'language'">
        <span class="spacingShow" @click="languageClick(item)">{{item.label}}</span>
        <span v-if="i<languageList.length -1" class="spacingLine"> | </span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import Cookies from 'js-cookie'

const iconMap = {
  tw: 'tc',
  kr: 'korean',
  jp: 'japan'
}
export default{
  name: 'CommonHeader',
  components: {},
  data() {
    return {

    }
  },
  computed: {
    imagePathLogo() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/logo.png`);
    }
  },
  props: {
    logo: { // 顶部菜单logo
      type: String,
      default: ''
    },
    menuList: { // 菜单列表
      type: Array,
      default: () => []
    },
    menuActive: { // 当前菜单
      type: String,
      default: ''
    },
    languageList: { // 语言列表
      type: Array,
      default: () => [
        {id:'japan',label: 'JP'},
        {id:'korean',label: 'KR'},
        {id:'tc',label: '繁體中文'},
      ]
    }
  },
  mounted() {

  },
  methods: {
    ...mapMutations(['SET_LANGUAGE']),
    toIndex(){
      // this.$router.push('/')
      this.$emit('logoClick')
    },
    menuClick(row){
      this.$emit('menuClick',row)
    },
    languageClick(row){
      // this.$emit('languageChange',row)
      this.pageLanguage = row.id
      this.SET_LANGUAGE(this.pageLanguage)  // 更新 Vuex 中的语言
      Cookies.set('language', this.pageLanguage)  // 将语言保存到 cookies 中
      // if (process.env.NODE_ENV === 'production') {
      //   let urlLib = {
      //     japan: 'jp',
      //     korean: 'kr',
      //     tc: 'tw'
      //   }
      //   let basePath = 'https://www.wildcaly.com/';
      //   let path = urlLib[row.id];
      //   window.location.href = `${basePath}${path}`;
      // }else {
      //   if (this.$route.path === '/') {
      //     location.reload();
      //   } else {
      //     this.$router.push('/',() => {
      //       location.reload();
      //     })
      //   }
      // }

      let urlLib = {
        japan: 'jp',
        korean: 'kr',
        tc: 'tw'
      }
      let basePath = 'https://www.wildcaly.com/';
      let path = urlLib[row.id];
      window.location.href = `${basePath}${path}/`;
    }
  }
}
</script>

<style lang="scss" scoped>
.headerMain{
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  .logoAndNav{
    display: flex;
    @media screen and (max-width: 1920px) {
      .logoShow{
        height: 60px;
        line-height: 60px;
        color: white;
        margin-left: 178px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img{
          width: 100px;
        }
      }
      .navList{
        width: auto;
        height: 100%;
        color: white;
        line-height: 62px;
        font-size: 14px;
        margin-left: 117px;
        ul{
          width: 400px;
          margin: 0;
          overflow: hidden;
          list-style: none;
          display: flex;
          justify-content: center;
          .navListShow{
            flex: 1;
            text-align: center;
            cursor: pointer;
          }
          .navListActive{
            background: linear-gradient(to bottom, rgba(255,255,255,0), #296ae3)
          }
        }
      }
    }
    @media screen and (min-width: 1921px) and (max-width: 2560px) {
      .logoShow{
        height: 80px;
        line-height: 80px;
        color: white;
        margin-left: 178px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img{
          width: 100px;
        }
      }
      .navList{
        width: auto;
        height: 100%;
        color: white;
        line-height: 82px;
        font-size: 20px;
        margin-left: 137px;
        ul{
          width: 440px;
          margin: 0;
          overflow: hidden;
          list-style: none;
          display: flex;
          justify-content: center;
          .navListShow{
            flex: 1;
            text-align: center;
            cursor: pointer;
          }
          .navListActive{
            background: linear-gradient(to bottom, rgba(255,255,255,0), #296ae3)
          }
        }
      }
    }
    @media screen and (min-width: 2561px){
      .logoShow{
        height: 100px;
        line-height: 100px;
        color: white;
        margin-left: 200px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img{
          height: 90px;
        }
      }
      .navList{
        width: auto;
        height: 100%;
        color: white;
        line-height: 102px;
        font-size: 30px;
        margin-left: 117px;
        ul{
          width: 20vw;
          margin: 0;
          overflow: hidden;
          list-style: none;
          display: flex;
          justify-content: center;
          .navListShow{
            flex: 1;
            text-align: center;
            cursor: pointer;
          }
          .navListActive{
            background: linear-gradient(to bottom, rgba(255,255,255,0), #296ae3)
          }
        }
      }
    }
  }
  @media screen and (max-width: 1920px) {
    .languageList {
      height: 100%;
      display: flex;
      align-items: center;
      position: relative;
      color: #7097E1;
      margin-right: 180px;
      .languageListShow{
        display: flex;
        .spacingShow{
          cursor: pointer;
          margin: 0 5px;
        }
      }
    }
  }
  @media screen and (min-width: 1920px) and (max-width: 2560px){
    .languageList {
      height: 100%;
      display: flex;
      align-items: center;
      position: relative;
      color: #7097E1;
      margin-right: 180px;
      .languageListShow{
        display: flex;
        .spacingShow{
          cursor: pointer;
          margin: 0 5px;
          font-size: 20px;
        }
        .spacingLine{
          font-size: 20px;
        }
      }
    }
  }
  @media screen and (min-width: 2561px){
    .languageList {
      height: 100px;
      display: flex;
      align-items: center;
      position: relative;
      color: #7097E1;
      margin-right: 180px;
      .languageListShow{
        display: flex;
        .spacingShow{
          cursor: pointer;
          margin: 0 5px;
          font-size: 30px;
        }
        .spacingLine{
          font-size: 30px;
        }
      }
    }
  }
}
</style>
